/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Tab_WindowsInputs */

const en_pc_dl_tab_windows = /** @type {(inputs: Pc_Dl_Tab_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

const zh_pc_dl_tab_windows = /** @type {(inputs: Pc_Dl_Tab_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

/**
* | output |
* | --- |
* | "Windows" |
*
* @param {Pc_Dl_Tab_WindowsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_tab_windows = /** @type {((inputs?: Pc_Dl_Tab_WindowsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Tab_WindowsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_tab_windows(inputs)
	return zh_pc_dl_tab_windows(inputs)
});
export { pc_dl_tab_windows as "pc.dl.tab.windows" }